var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppsFactoryTxt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 135.6 59.9",
    style: {
      enableBackground: "new 0 0 135.6 59.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n\t.st1{fill:#444444;}\n\t.st2{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.1,13.1H4.9l-1.6,4H2.2L8.4,0.8h1.3l6.2,16.2h-1.3L13.1,13.1z M12.4,11.8L8.9,2.5l-3.3,9.3H12.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.5,6.1c0,2.7-2.2,4.9-4.9,4.9h-4.4v6H19V0.8h5.3C27.7,0.8,29.5,3,29.5,6.1z M28.6,6.1 c0-2.2-1.6-3.8-3.8-3.8h-4.4v7.8h4.4C26.8,10,28.6,8.3,28.6,6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.3,6.1c0,2.7-2.2,4.9-4.9,4.9H35v6h-1.3V0.8H39C42.1,0.8,44.3,3,44.3,6.1z M43.1,6.1 c0-2.2-1.6-3.8-3.8-3.8h-4.4v7.8h4.4C41.4,10,43.1,8.3,43.1,6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.9,13.6l0.9-0.5c0.5,1.8,2.2,3.1,4.7,3.1c2.7,0,4-1.3,4-3.1s-1.6-2.7-4-3.5c-2.7-0.9-4.9-1.6-4.9-4.4 c0-2.6,2.2-4.4,4.9-4.4c2.6,0,4.4,1.6,5.3,3.5l-1.1,0.5c-0.5-1.6-1.8-2.7-4-2.7s-3.8,1.3-3.8,3.1s1.6,2.6,4,3.1 c2.7,0.9,5.3,1.8,5.3,4.7s-2.2,4.4-5.7,4.4C50,17.4,47.8,15.8,46.9,13.6z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    className: "st1",
    d: "M1.3,51V39.2h14.1v4H4.5v8C4.5,51,1.3,51,1.3,51z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    className: "st1",
    d: "M1.3,29.5l3.8,3.8h10.6v-3.8H1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    className: "st1",
    d: "M16.2,51l11-21.5l7.1,14.4h-4l-3.1-6L20.8,51H16.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    className: "st1",
    d: "M31.7,47.9h4l1.6,3.1h-4L31.7,47.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    className: "st1",
    d: "M58.9,51V29.5h10.6v3.8h-7.1v17.9h-3.5V51z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 83,
    cy: 40.3,
    r: 11
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M83,51c-6,0-11-4.7-11-11s4.7-11,11-11c6.2,0,10.6,4.9,10.6,11S88.7,51,83,51z M83,33.7 c-3.8,0-6.6,2.7-6.6,6.6s2.7,6.6,6.6,6.6c3.8,0,6.6-2.7,6.6-6.6S86.5,33.7,83,33.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    className: "st1",
    d: "M113.9,29.5h4l6,7.8l5.7-7.8h4.7v1.3L118.4,51h-4l8.4-11L113.9,29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M52.2,46.5l3.1,3.1c-1.6,0.9-3.5,1.5-5.7,1.5c-6,0-11-4.9-11-11s4.7-11,11-11c2.6,0,4.7,0.9,6.6,2.2l-2.7,3.1 c-0.9-0.9-2.6-1.3-3.8-1.3c-3.8,0-6.6,2.7-6.6,6.6s2.7,6.6,6.6,6.6C50.5,47,51.1,46.6,52.2,46.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.6,47c-3.8,0-6.6-2.7-6.6-6.6s2.7-6.6,6.6-6.6c1.6,0,2.7,0.4,3.8,1.3l2.7-3.1c-1.8-1.6-4-2.2-6.6-2.2 c-6,0-11,4.7-11,11s4.7,11,11,11c2.2,0,4-0.5,5.7-1.6L52.2,47C51.1,46.6,50.5,47,49.6,47z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    className: "st1",
    d: "M94.3,29.5l2.6,3.8h8.8c2.6,0,5.7,7.8-4.7,7.1v1.3l6,9.7h4.4l-4.7-8c0,0,4.9-1.3,4.9-6.2 c0.4-4.9-2.7-7.8-7.8-7.5C103.7,29.5,94.3,29.5,94.3,29.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppsFactoryTxt);
export default __webpack_public_path__ + "static/media/AppsFactory-txt.40709e49201777d6cc18504bcd6ec766.svg";
export { ForwardRef as ReactComponent };